import { generatePath } from "react-router-dom";
import {
    DocumentManagerType,
    // AspectTypeEnum,
    // DataTypeEnum,
    // VariableTypeEnum,
} from "../api/APIClient";

const routePrefix = "/app";
const administrationPath = `${routePrefix}/administration`;
const projectPath = `${routePrefix}/project/:projectId`;
const toolsPath = `${projectPath}/tools`;
const documentationPath = `${toolsPath}/documentation`;
const maintenancePath = `${toolsPath}/maintenance`;
const settingsPath = `${projectPath}/settings`;
const signalsPath = `${projectPath}/signals`;

export const BDTRoutes = {
    Prefix: routePrefix,
    Home: routePrefix,
    Administration: {
        Administration: administrationPath,
        ForgeAccounts: `${administrationPath}/forgeAccounts`,
        Models: `${administrationPath}/models`,
        Projects: `${administrationPath}/projects`,
        Users: `${administrationPath}/users`,
        UsersGroups: `${administrationPath}/usersGroups`,
        // Aspects: `${administrationPath}/aspects`,
        // AssetTypes: `${administrationPath}/assettypes`,
        PowerBIAccounts: `${administrationPath}/powerBIAccounts`,
    },
    Project: {
        Project: {
            Path: projectPath,
            Builder: (projectId: string): string =>
                generatePath(`${routePrefix}/project/:projectId`, { projectId }),
        },
        DashboardPowerBI: {
            Path: `${projectPath}/dashboardpowerbi`,
            Builder: (projectId: string): string =>
                generatePath(`${routePrefix}/project/:projectId/dashboardpowerbi`, { projectId }),
        },
        DashboardPowerApps: {
            Path: `${projectPath}/dashboardpowerapps`,
            Builder: (projectId: string): string =>
                generatePath(`${routePrefix}/project/:projectId/dashboardpowerapps`, { projectId }),
        },
        Dashboard: {
            Path: `${projectPath}/dashboard`,
            Builder: (projectId: string): string =>
                generatePath(`${routePrefix}/project/:projectId/dashboard`, { projectId }),
        },
        Viewer: {
            Viewer: {
                Path: `${projectPath}/viewer/:modelId?`,
                Builder: (projectId: string, modelId?: string): string =>
                    generatePath(`${routePrefix}/project/:projectId/viewer/:modelId?`, {
                        projectId,
                        modelId,
                    }),
            },
            Assets: {
                Path: `${projectPath}/viewer/:modelId/assets`,
                Builder: (projectId: string, modelId: string): string =>
                    generatePath(`${routePrefix}/project/:projectId/viewer/:modelId/assets`, {
                        projectId,
                        modelId,
                    }),
            },
            WorkOrders: {
                Path: `${projectPath}/viewer/:modelId/workOrders`,
                Builder: (projectId: string, modelId?: string): string =>
                    generatePath(`${routePrefix}/project/:projectId/viewer/:modelId?/workOrders`, {
                        projectId,
                        modelId,
                    }),
            },
            Documentation: {
                Path: `${projectPath}/viewer/:modelId/documentation`,
                Builder: (projectId: string, modelId: string): string =>
                    generatePath(
                        `${routePrefix}/project/:projectId/viewer/:modelId/documentation`,
                        {
                            projectId,
                            modelId,
                        }
                    ),
            },
            PowerBI: {
                Path: `${projectPath}/viewer/:modelId/powerbi`,
                Builder: (projectId: string, modelId?: string): string =>
                    generatePath(`${routePrefix}/project/:projectId/viewer/:modelId?/powerbi`, {
                        projectId,
                        modelId,
                    }),
            },
        },
        Tools: {
            Tools: {
                Path: toolsPath,
                Builder: (projectId: string): string => generatePath(`${toolsPath}`, { projectId }),
            },
            Documentation: {
                Path: documentationPath,
                Builder: (projectId: string): string =>
                    generatePath(documentationPath, { projectId }),
                Connectors: {
                    Path: `${documentationPath}/connectors`,
                    Builder: (projectId: string): string =>
                        generatePath(`${documentationPath}/connectors`, { projectId }),
                },
                Import: {
                    Path: `${documentationPath}/import`,
                    Builder: (projectId: string): string =>
                        generatePath(`${documentationPath}/import`, { projectId }),
                },
                Management: {
                    Path: `${documentationPath}/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${documentationPath}/management`, { projectId }),
                },
            },
            // DataSources: {
            //     Path: `${toolsPath}/dataSources`,
            //     Builder: (projectId: string): string =>
            //         generatePath(`${toolsPath}/dataSources`, { projectId }),
            //     Files: {
            //         Path: `${toolsPath}/dataSources/files`,
            //         Builder: (projectId: string): string =>
            //             generatePath(`${toolsPath}/dataSources/files`, { projectId }),
            //     },
            //     DataBases: {
            //         Path: `${toolsPath}/dataSources/dataBases`,
            //         Builder: (projectId: string): string =>
            //             generatePath(`${toolsPath}/dataSources/dataBases`, { projectId }),
            //     },
            // },
            Maintenance: {
                Path: maintenancePath,
                Builder: (projectId: string): string =>
                    generatePath(maintenancePath, { projectId }),
                Connectors: {
                    Path: `${maintenancePath}/connectors`,
                    Builder: (projectId: string): string =>
                        generatePath(`${maintenancePath}/connectors`, { projectId }),
                },
                // WorkOrders: {
                //     Path: `${maintenancePath}/workOrders`,
                //     Builder: (projectId: string): string =>
                //         generatePath(`${maintenancePath}/workOrders`, { projectId }),
                // },
                // Rules: {
                //     Rules: {
                //         Path: `${maintenancePath}/rules`,
                //         Builder: (projectId: string): string =>
                //             generatePath(`${maintenancePath}/rules`, { projectId }),
                //     },
                //     RuleDetails: {
                //         Path: `${maintenancePath}/rules/:ruleId`,
                //         Builder: (projectId: string, ruleId: string): string =>
                //             generatePath(`${maintenancePath}/rules/:ruleId`, { projectId, ruleId }),
                //     },
                // },
            },
        },
        Settings: {
            Path: settingsPath,
            Builder: (projectId: string): string => generatePath(`${settingsPath}`, { projectId }),
            // Assets: {
            //     Path: `${settingsPath}/assets`,
            //     Builder: (projectId: string): string =>
            //         generatePath(`${settingsPath}/assets`, { projectId }),
            //     Management: {
            //         Path: `${settingsPath}/assets/management`,
            //         Builder: (projectId: string): string =>
            //             generatePath(`${settingsPath}/assets/management`, { projectId }),
            //     },
            // },
            PowerBI: {
                Path: `${settingsPath}/powerbi`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/powerbi`, { projectId }),
                Management: {
                    Path: `${settingsPath}/powerbi/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/powerbi/management`, { projectId }),
                },
                AssetsManagement: {
                    Path: `${settingsPath}/powerbi/assetsmanagement`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/powerbi/assetsmanagement`, { projectId }),
                },
            },
            Documents: {
                Path: `${settingsPath}/documentation`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/documentation`, {
                        projectId,
                    }),
                Management: {
                    Path: `${settingsPath}/documentation/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/documentation/management`, { projectId }),
                },
                AssetsManagement: {
                    Path: `${settingsPath}/documentation/documentationassetsmanagement`,
                    Builder: (projectId: string): string =>
                        generatePath(
                            `${settingsPath}/documentation/documentationassetsmanagement`,
                            { projectId }
                        ),
                },
            },
            PowerApps: {
                Path: `${settingsPath}/powerapps`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/powerapps`, { projectId }),
            },
            // Teams: {
            //     Path: `${settingsPath}/teams`,
            //     Builder: (projectId: string): string =>
            //         generatePath(`${settingsPath}/teams`, { projectId }),
            // },
            AssetControl: {
                Path: `${settingsPath}/assetcontrol`,
                Builder: (projectId: string): string =>
                    generatePath(`${settingsPath}/assetcontrol`, { projectId }),
                Management: {
                    Path: `${settingsPath}/assetcontrol/management`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/assetcontrol/management`, { projectId }),
                },
                Views: {
                    Path: `${settingsPath}/assetcontrol/views`,
                    Builder: (projectId: string): string =>
                        generatePath(`${settingsPath}/assetcontrol/views`, { projectId }),
                },
            },
        },
        Signals: {
            Path: signalsPath,
            Builder: (projectId: string): string => generatePath(`${signalsPath}`, { projectId }),
        },
    },
};

export interface IPlatformType {
    id: number;
    key: string;
}

type IConnectorTypes = {
    [key in DocumentManagerType]: IPlatformType;
};

export const CONNECTOR_TYPES: IConnectorTypes = {
    [DocumentManagerType.NextCloud]: {
        id: DocumentManagerType.NextCloud,
        key: "NextCloud",
    },
    [DocumentManagerType.AzureBlobStorage]: {
        id: DocumentManagerType.AzureBlobStorage,
        key: "AzureBlobStorage",
    },
};

// type IAspectTypes = {
//     [key in AspectTypeEnum]: IPlatformType;
// };

// export const AspectTypes: IAspectTypes = {
//     [AspectTypeEnum.Dynamic]: {
//         id: AspectTypeEnum.Dynamic,
//         key: "dinamic",
//     },
//     [AspectTypeEnum.Static]: {
//         id: AspectTypeEnum.Static,
//         key: "static",
//     },
// };

// type IDataTypes = {
//     [key in DataTypeEnum]: IPlatformType;
// };

// export const DataTypes: IDataTypes = {
//     [DataTypeEnum.Boolean]: {
//         id: DataTypeEnum.Boolean,
//         key: "boolean",
//     },
//     [DataTypeEnum.Int]: {
//         id: DataTypeEnum.Int,
//         key: "int",
//     },
//     [DataTypeEnum.Long]: {
//         id: DataTypeEnum.Long,
//         key: "long",
//     },
//     [DataTypeEnum.Double]: {
//         id: DataTypeEnum.Double,
//         key: "double",
//     },
//     [DataTypeEnum.String]: {
//         id: DataTypeEnum.String,
//         key: "dtring",
//     },
//     [DataTypeEnum.DateTime]: {
//         id: DataTypeEnum.DateTime,
//         key: "dateTime",
//     },
// };

// type IVariableTypes = {
//     [key in VariableTypeEnum]: IPlatformType;
// };

// export const VariableTypes: IVariableTypes = {
//     [VariableTypeEnum.Value]: {
//         id: VariableTypeEnum.Value,
//         key: "value",
//     },
//     [VariableTypeEnum.TimeSeries]: {
//         id: VariableTypeEnum.TimeSeries,
//         key: "timeSeries",
//     },
// };

export const ModelViewerModes = {
    Viewer: "viewer",
    Assets: "assets",
    Documentation: "documentation",
    WorkOrders: "workorders",
};

export enum GeometriesEnum {
    Sphere = 1,
    Cuboid = 2,
    Cylinder = 3,
    NotGeometry = 4,
}

export interface IPowerBIReportElementData {
    id: string;
    assetName: string;
    data: { [key: string]: string };
}

export /* declare */ enum ModelViewerPanelAnchor {
    Top,
    Bottom,
    Left,
    Right,
}
